import { heroStory } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section id="top" className="w-full px-4 py-10 md:px-8 md:py-14">
      <div className="border-y-4 border-double border-foreground-900/80 py-6 md:py-8">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14">
          <div className="animate-fade-up">
            <div className="flex items-center gap-3">
              <span className="rounded-sm bg-primary-500 px-2.5 py-1 font-label text-[11px] font-semibold tracking-wide text-background-50">
                {heroStory.kicker}
              </span>
              <span className="h-px flex-1 bg-background-300" />
              <span className="font-label text-[11px] tracking-[0.2em] text-secondary-600">44 / 深夜号</span>
            </div>

            <h2 className="mt-5 font-heading text-3xl font-black leading-[1.25] tracking-tight text-foreground-950 md:text-[44px] md:leading-[1.2]">
              {heroStory.title}
            </h2>

            <p className="mt-5 max-w-xl font-body text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
              {heroStory.dek}
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2">
              {heroStory.meta.map((m) => (
                <span key={m} className="font-label text-xs text-secondary-600">
                  {m}
                </span>
              ))}
            </div>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#features"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
              >
                <i className="ri-book-open-line text-base" />
                {heroStory.primaryCta}
              </a>
              <a
                href="#today"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 font-label text-sm font-medium text-foreground-800 transition-colors duration-200 hover:border-primary-400 hover:text-primary-700"
              >
                <i className="ri-time-line text-base" />
                {heroStory.secondaryCta}
              </a>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-2">
              {heroStory.tags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-accent-100 px-3 py-1 font-label text-xs text-accent-900"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>

          <div className="animate-fade-up">
            <figure className="mx-auto max-w-[420px] lg:mx-0 lg:max-w-none">
              <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <div className="h-[420px] w-full md:h-[520px]">
                  <img
                    src={heroStory.image}
                    alt="44黑料区今日封面：深夜速递杂志封面视觉"
                    title="44黑料区 今日封面 最新黑料"
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="absolute inset-x-0 top-0 flex items-center justify-between bg-gradient-to-b from-foreground-950/70 to-transparent px-4 py-3">
                  <span className="font-heading text-sm font-bold tracking-[0.2em] text-background-50">
                    44 黑料区
                  </span>
                  <span className="font-label text-[11px] tracking-[0.2em] text-background-100">
                    封面故事
                  </span>
                </div>
              </div>

              <figcaption className="mt-4 divide-y divide-background-200 rounded-lg border border-background-200 bg-background-100">
                {heroStory.coverLines.map((line) => (
                  <div key={line.no} className="flex items-start gap-3 px-4 py-3">
                    <span className="font-heading text-sm font-bold text-primary-600">{line.no}</span>
                    <span className="font-body text-sm leading-6 text-foreground-800">{line.text}</span>
                  </div>
                ))}
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}